import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface ConfirmDeleteData {
    empleadoNombre: string;
    fechaInicio: string;
    motivo: string;
}

@Component({
    selector: 'app-bajas-confirm-delete',
    templateUrl: './bajas-confirm-delete.component.html',
    styleUrls: ['./bajas-confirm-delete.component.css'],
    standalone: false
})
export class BajasConfirmDeleteComponent {
    constructor(
        public dialogRef: MatDialogRef<BajasConfirmDeleteComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ConfirmDeleteData
    ) { }

    confirmar(): void {
        this.dialogRef.close(true);
    }
}
